// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConversationIdBuf } from '../conversation/conversation-id-buf.js';
import { InterfacePanelState } from '../interface/interface-panel-state.js';
import { InterfaceSidebarState } from '../interface/interface-sidebar-state.js';


/**
 * A flat table of all user interface settings. We should
 * try to minimize any nesting here, since these settings
 * will evolve over time and users won't have the newest
 * flatbuffer version. Additionally, all these properties
 * should be optional, and usually just a simple int or 
 * boolean should suffice. The default values for this
 * table are set at the user level, so the defaults for
 * these should always be null, if possible.
 */
export class UserInterfaceSettingsBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):UserInterfaceSettingsBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsUserInterfaceSettingsBuf(bb:flatbuffers.ByteBuffer, obj?:UserInterfaceSettingsBuf):UserInterfaceSettingsBuf {
  return (obj || new UserInterfaceSettingsBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsUserInterfaceSettingsBuf(bb:flatbuffers.ByteBuffer, obj?:UserInterfaceSettingsBuf):UserInterfaceSettingsBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new UserInterfaceSettingsBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

panelState():InterfacePanelState {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : InterfacePanelState.Hidden;
}

panelWidth():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : null;
}

sidebarState():InterfaceSidebarState {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : InterfaceSidebarState.Hidden;
}

sidebarWidth():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : null;
}

previewFadeOnDwell():boolean|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null;
}

latestConversationId(obj?:ConversationIdBuf):ConversationIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new ConversationIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

/**
 * Whether onboarding is completed. For users that just signed up, we
 * need to take them to onboarding if they have not completed it, and
 * then we check this off after the user has been given the onboarding
 * content.
 */
onboardingComplete():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startUserInterfaceSettingsBuf(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addPanelState(builder:flatbuffers.Builder, panelState:InterfacePanelState) {
  builder.addFieldInt8(0, panelState, InterfacePanelState.Hidden);
}

static addPanelWidth(builder:flatbuffers.Builder, panelWidth:number) {
  builder.addFieldInt32(1, panelWidth, null);
}

static addSidebarState(builder:flatbuffers.Builder, sidebarState:InterfaceSidebarState) {
  builder.addFieldInt8(2, sidebarState, InterfaceSidebarState.Hidden);
}

static addSidebarWidth(builder:flatbuffers.Builder, sidebarWidth:number) {
  builder.addFieldInt32(3, sidebarWidth, null);
}

static addPreviewFadeOnDwell(builder:flatbuffers.Builder, previewFadeOnDwell:boolean) {
  builder.addFieldInt8(4, +previewFadeOnDwell, null);
}

static addLatestConversationId(builder:flatbuffers.Builder, latestConversationIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, latestConversationIdOffset, 0);
}

static addOnboardingComplete(builder:flatbuffers.Builder, onboardingComplete:boolean) {
  builder.addFieldInt8(6, +onboardingComplete, +false);
}

static endUserInterfaceSettingsBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
